// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tribe-container {
    background-color: #000;
    color: #fff;
    padding: 40px;
    width: 100%;
    box-sizing: border-box;
    padding-top: 100px;
  }
  
  .tribe-content {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    align-items: center;
  }
  
  .tribe-image-container {
    width: 100%;
    aspect-ratio: 1 / 1;
  }
  
  .tribe-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .tribe-text-content {
    padding: 20px;
  }
  
  .tribe-title {
    font-size: 80px;
    font-weight: 800;
    margin: 0 0 20px 0;
    line-height: 77px;
    text-transform: uppercase;
    font-family: Thicker;
  }
  
  .tribe-subtitle {
    font-size: 2.5rem;
    font-weight: 700;
    margin: 0 0 20px 0;
  }
  
  .highlight {
    color: #b22222;
  }
  
  .tribe-description {
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 30px;
  }
  
  .know-more-button-new {
    background-color: #b22222;
    color: white;
    border: none;
    padding: 12px 30px;
    font-size: 1.1rem;
    font-weight: bold;
    cursor: pointer;
  }
  
  .know-more-button-new:hover {
    background-color: #8b1a1a;
  }
  
  @media (max-width: 768px) {
    .tribe-container {
      padding: 40px 20px;
    }

    .tribe-content {
      grid-template-columns: 1fr;
      gap: 30px;
    }

    .tribe-title {
      font-size: 36px;
      line-height: 44px;
      text-align: left;
    }

    .tribe-subtitle {
      font-size: 24px;
      text-align: left;
    }

    .tribe-description {
      font-size: 16px;
      text-align: left;
    }

    .know-more-button-new {
      display: block;
      margin: 0 auto;
      
    }
  }
  

  `, "",{"version":3,"sources":["webpack://./src/components/newSeason/tribe.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,0BAA0B;MAC1B,SAAS;IACX;;IAEA;MACE,eAAe;MACf,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,cAAc;MACd,cAAc;;IAEhB;EACF","sourcesContent":[".tribe-container {\n    background-color: #000;\n    color: #fff;\n    padding: 40px;\n    width: 100%;\n    box-sizing: border-box;\n    padding-top: 100px;\n  }\n  \n  .tribe-content {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 40px;\n    align-items: center;\n  }\n  \n  .tribe-image-container {\n    width: 100%;\n    aspect-ratio: 1 / 1;\n  }\n  \n  .tribe-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .tribe-text-content {\n    padding: 20px;\n  }\n  \n  .tribe-title {\n    font-size: 80px;\n    font-weight: 800;\n    margin: 0 0 20px 0;\n    line-height: 77px;\n    text-transform: uppercase;\n    font-family: Thicker;\n  }\n  \n  .tribe-subtitle {\n    font-size: 2.5rem;\n    font-weight: 700;\n    margin: 0 0 20px 0;\n  }\n  \n  .highlight {\n    color: #b22222;\n  }\n  \n  .tribe-description {\n    font-size: 1.1rem;\n    line-height: 1.6;\n    margin-bottom: 30px;\n  }\n  \n  .know-more-button-new {\n    background-color: #b22222;\n    color: white;\n    border: none;\n    padding: 12px 30px;\n    font-size: 1.1rem;\n    font-weight: bold;\n    cursor: pointer;\n  }\n  \n  .know-more-button-new:hover {\n    background-color: #8b1a1a;\n  }\n  \n  @media (max-width: 768px) {\n    .tribe-container {\n      padding: 40px 20px;\n    }\n\n    .tribe-content {\n      grid-template-columns: 1fr;\n      gap: 30px;\n    }\n\n    .tribe-title {\n      font-size: 36px;\n      line-height: 44px;\n      text-align: left;\n    }\n\n    .tribe-subtitle {\n      font-size: 24px;\n      text-align: left;\n    }\n\n    .tribe-description {\n      font-size: 16px;\n      text-align: left;\n    }\n\n    .know-more-button-new {\n      display: block;\n      margin: 0 auto;\n      \n    }\n  }\n  \n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
